(function () {
  "use strict";

  var data = window.__BRAND__ || {};
  var I18N = window.__I18N__ || {};
  var LANG_KEY = "velodynn_lang";
  var SUPPORTED_LANGS = ["es", "ca", "en", "fr"];
  var currentLang = "es";
  var reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var fineHover = matchMedia("(hover: hover) and (pointer: fine)").matches;

  var $ = function (sel, scope) { return (scope || document).querySelector(sel); };
  var $$ = function (sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); };
  var escHTML = function (s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c];
    });
  };
  function safe(fn, name) {
    try { fn(); } catch (e) { console.warn("[" + name + "]", e); }
  }

  // ---------------------------------------------------------------
  // Mounts (idempotent — fill only if empty)
  // ---------------------------------------------------------------
  function mountNav() {
    var target = $("[data-nav-links]");
    if (!target || target.children.length > 0 || !data.nav) return;
    target.innerHTML = data.nav.map(function (n) {
      return '<a class="nav-link" href="' + escHTML(n.href) + '">' + escHTML(n.label) + "</a>";
    }).join("");
  }

  function mountPillars() {
    var target = $("[data-pillars]");
    if (!target || target.children.length > 0 || !data.pillars) return;
    target.innerHTML = data.pillars.map(function (p, i) {
      return (
        '<div class="pillar" data-reveal style="transition-delay:' + (i * 0.08) + 's">' +
          '<span class="pillar-num">0' + (i + 1) + "</span>" +
          "<h3>" + escHTML(p.title) + "</h3>" +
          "<p>" + escHTML(p.body) + "</p>" +
        "</div>"
      );
    }).join("");
  }

  function mountDetails() {
    var target = $("[data-details]");
    if (!target || target.children.length > 0 || !data.details) return;
    target.innerHTML = data.details.map(function (d) {
      return (
        '<article class="card" data-reveal>' +
          '<div class="card-img-wrap">' +
            '<img class="card-img" src="' + escHTML(d.image) + '" alt="' + escHTML(d.alt) + '" loading="lazy" decoding="async" />' +
          "</div>" +
          '<div class="card-body">' +
            "<h3>" + escHTML(d.title) + "</h3>" +
            "<p>" + escHTML(d.body) + "</p>" +
          "</div>" +
        "</article>"
      );
    }).join("");
  }

  function mountFooterMeta() {
    var email = $("[data-email]");
    if (email && data.email) { email.textContent = data.email; email.href = "mailto:" + data.email; }
    var ig = $("[data-instagram]");
    if (ig && data.instagram) { ig.textContent = data.instagram.handle; ig.href = data.instagram.url; }
    var coords = $$("[data-coords]");
    coords.forEach(function (el) { if (data.coords) el.textContent = data.coords; });
  }

  // ---------------------------------------------------------------
  // Splash — double safety net (CSS handles the 4.5s fallback)
  // ---------------------------------------------------------------
  function initSplash() {
    var splash = $("[data-splash]");
    if (!splash) return;
    var hide = function () { splash.classList.add("is-out"); };
    if (document.readyState === "complete") setTimeout(hide, 700);
    else window.addEventListener("load", function () { setTimeout(hide, 500); });
    setTimeout(hide, 3600);
  }

  // ---------------------------------------------------------------
  // Sticky nav — transparent to solid
  // ---------------------------------------------------------------
  function initNav() {
    var nav = $(".nav");
    if (!nav) return;
    var on = function () {
      if (scrollY > 60) nav.classList.add("is-scrolled");
      else nav.classList.remove("is-scrolled");
    };
    on();
    window.addEventListener("scroll", on, { passive: true });

    var toggle = $("[data-nav-toggle]");
    var mobile = $("[data-nav-mobile]");
    if (toggle && mobile) {
      toggle.addEventListener("click", function () {
        var open = mobile.getAttribute("aria-hidden") === "false";
        mobile.setAttribute("aria-hidden", open ? "true" : "false");
        toggle.setAttribute("aria-expanded", open ? "false" : "true");
      });
      $$("a", mobile).forEach(function (a) {
        a.addEventListener("click", function () {
          mobile.setAttribute("aria-hidden", "true");
          toggle.setAttribute("aria-expanded", "false");
        });
      });
    }
  }

  // ---------------------------------------------------------------
  // Smooth anchor scroll (native — no Lenis, see gotcha B.1.4)
  // ---------------------------------------------------------------
  function initSmoothAnchors() {
    document.addEventListener("click", function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute("href");
      if (!id || id === "#") return;
      var el = document.querySelector(id);
      if (!el) return;
      e.preventDefault();
      var navOffset = 112; // nav (76) + announcement bar (~36)
      window.scrollTo({
        top: el.getBoundingClientRect().top + scrollY - navOffset,
        behavior: reduced ? "auto" : "smooth"
      });
    });
  }

  // ---------------------------------------------------------------
  // Reveal on scroll — universal, with 6s safety net
  // ---------------------------------------------------------------
  function initReveals() {
    var els = $$("[data-reveal]");
    if (!els.length || typeof IntersectionObserver === "undefined") {
      els.forEach(function (el) { el.classList.add("is-revealed"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("is-revealed");
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.01, rootMargin: "0px 0px -2% 0px" });
    els.forEach(function (el) { io.observe(el); });

    setTimeout(function () {
      $$("[data-reveal]:not(.is-revealed)").forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add("is-revealed");
      });
    }, 6000);
  }

  // ---------------------------------------------------------------
  // Reveal-mask images — the "photo animates as you scroll" effect
  // ---------------------------------------------------------------
  function initMaskReveals() {
    var els = $$("[data-reveal-mask]");
    if (!els.length || typeof IntersectionObserver === "undefined") {
      els.forEach(function (el) { el.classList.add("is-revealed"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("is-revealed");
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });

    setTimeout(function () {
      els.forEach(function (el) {
        if (!el.classList.contains("is-revealed") && el.getBoundingClientRect().top < window.innerHeight) {
          el.classList.add("is-revealed");
        }
      });
    }, 6000);
  }

  // ---------------------------------------------------------------
  // GSAP-dependent: hero parallax + section image parallax
  // ---------------------------------------------------------------
  function initHeroParallax() {
    if (!window.gsap || !window.ScrollTrigger || reduced) return;
    var heroBg = $(".hero-bg img");
    var heroContent = $(".hero-content");
    if (heroBg) {
      gsap.to(heroBg, {
        yPercent: 18, scale: 1.12, ease: "none",
        scrollTrigger: { trigger: ".hero", start: "top top", end: "bottom top", scrub: true }
      });
    }
    if (heroContent) {
      gsap.to(heroContent, {
        yPercent: -30, opacity: 0.2, ease: "none",
        scrollTrigger: { trigger: ".hero", start: "top top", end: "bottom top", scrub: true }
      });
    }
  }

  function initPhotoParallax() {
    if (!window.gsap || !window.ScrollTrigger || reduced) return;
    $$("[data-parallax-img]").forEach(function (img) {
      gsap.to(img, {
        yPercent: -12, ease: "none",
        scrollTrigger: { trigger: img.closest("[data-parallax-wrap]") || img, start: "top bottom", end: "bottom top", scrub: 0.6 }
      });
    });
  }

  // ---------------------------------------------------------------
  // Tilt 3D on feature cards
  // ---------------------------------------------------------------
  function initTilt() {
    if (!fineHover) return;
    $$(".card, .pillar").forEach(function (card) {
      var MAX = 6;
      var tx = 0, ty = 0, cx = 0, cy = 0, raf = null;
      card.classList.add("has-tilt");
      card.addEventListener("mousemove", function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        tx = -py * MAX; ty = px * MAX;
        card.style.setProperty("--mx", ((px + 0.5) * 100) + "%");
        card.style.setProperty("--my", ((py + 0.5) * 100) + "%");
        if (!raf) raf = requestAnimationFrame(loop);
      });
      card.addEventListener("mouseleave", function () {
        tx = 0; ty = 0;
        if (!raf) raf = requestAnimationFrame(loop);
      });
      function loop() {
        cx += (tx - cx) * 0.15; cy += (ty - cy) * 0.15;
        card.style.setProperty("--rx", cx.toFixed(2) + "deg");
        card.style.setProperty("--ry", cy.toFixed(2) + "deg");
        raf = (Math.abs(tx - cx) > 0.05 || Math.abs(ty - cy) > 0.05) ? requestAnimationFrame(loop) : null;
      }
    });
  }

  // ---------------------------------------------------------------
  // Magnetic primary CTA (never on form submit buttons)
  // ---------------------------------------------------------------
  function initMagnetic() {
    if (!fineHover) return;
    $$("[data-magnetic]").forEach(function (el) {
      var strength = parseFloat(el.dataset.magneticStrength || "0.25");
      var inner = document.createElement("span");
      inner.className = "magnetic-inner";
      while (el.firstChild) inner.appendChild(el.firstChild);
      el.appendChild(inner);
      el.classList.add("has-magnetic");
      var tx = 0, ty = 0, cx = 0, cy = 0, raf = null;
      el.addEventListener("mousemove", function (e) {
        var r = el.getBoundingClientRect();
        tx = ((e.clientX - r.left) - r.width / 2) * strength;
        ty = ((e.clientY - r.top) - r.height / 2) * strength;
        if (!raf) raf = requestAnimationFrame(loop);
      });
      el.addEventListener("mouseleave", function () {
        tx = 0; ty = 0;
        if (!raf) raf = requestAnimationFrame(loop);
      });
      function loop() {
        cx += (tx - cx) * 0.2; cy += (ty - cy) * 0.2;
        inner.style.transform = "translate3d(" + cx + "px, " + cy + "px, 0)";
        raf = (Math.abs(tx - cx) > 0.1 || Math.abs(ty - cy) > 0.1) ? requestAnimationFrame(loop) : null;
      }
    });
  }

  // ---------------------------------------------------------------
  // Signature mark — click/tap toggles the reveal (hover handles it on desktop)
  // ---------------------------------------------------------------
  function initSignature() {
    $$("[data-signature]").forEach(function (el) {
      el.addEventListener("click", function () {
        el.classList.toggle("is-active");
      });
    });
  }

  // ---------------------------------------------------------------
  // Drag-to-rotate product viewer (front/back card flip)
  // ---------------------------------------------------------------
  function initFlip3D() {
    $$("[data-flip3d]").forEach(function (root) {
      var stage = root.querySelector("[data-flip3d-stage]");
      if (!stage) return;
      var current = 0;
      var startX = 0;
      var startAngle = 0;
      var dragging = false;
      var moved = false;

      function setAngle(a, animate) {
        stage.style.transition = animate ? "" : "none";
        // Cylinder illusion: narrow the card as it turns edge-on, like a
        // rounded volume rather than a flat sheet rotating on a hinge.
        var rad = (a * Math.PI) / 180;
        var squeeze = 0.78 + 0.22 * Math.abs(Math.cos(rad));
        stage.style.transform = "scaleX(" + squeeze.toFixed(3) + ") rotateY(" + a + "deg)";
        // Shading follows the same curve: darkest at the edge-on point.
        // Set on root (not stage) so the shading overlay stays flat/camera-facing.
        root.style.setProperty("--flip-shade", (1 - Math.abs(Math.cos(rad))).toFixed(3));
        // Safety net: some browsers/embedded webviews don't honour
        // backface-visibility reliably, so also force the hidden face's
        // opacity via JS, matching the same crossover the CSS 3D uses.
        var mod = ((a % 360) + 360) % 360;
        var isBack = mod >= 90 && mod < 270;
        root.classList.toggle("is-flipped", isBack);
      }

      function snap() {
        var mod = ((current % 360) + 360) % 360;
        var nearestBase = mod < 90 || mod >= 270 ? Math.round(current / 360) * 360 : Math.round((current - 180) / 360) * 360 + 180;
        current = nearestBase;
        setAngle(current, true);
      }

      function down(clientX) {
        dragging = true;
        moved = false;
        startX = clientX;
        startAngle = current;
        root.classList.add("is-dragging");
        setAngle(current, false);
      }
      function move(clientX) {
        if (!dragging) return;
        var dx = clientX - startX;
        if (Math.abs(dx) > 3) moved = true;
        current = startAngle + dx * 0.6;
        setAngle(current, false);
      }
      function up() {
        if (!dragging) return;
        dragging = false;
        root.classList.remove("is-dragging");
        snap();
      }

      root.addEventListener("mousedown", function (e) { e.preventDefault(); down(e.clientX); });
      window.addEventListener("mousemove", function (e) { move(e.clientX); });
      window.addEventListener("mouseup", up);

      root.addEventListener("touchstart", function (e) { down(e.touches[0].clientX); }, { passive: true });
      root.addEventListener("touchmove", function (e) { move(e.touches[0].clientX); }, { passive: true });
      root.addEventListener("touchend", up);

      setAngle(0, false);
      root.__flip3dIsBack = function () { return root.classList.contains("is-flipped"); };
      root.__flip3dSetAngle = function (a, animate) { current = a; setAngle(a, animate); };

      root.addEventListener("click", function (e) {
        if (moved) { e.preventDefault(); return; }
        if (root.hasAttribute("data-flip3d-lightbox")) return;
        openLightbox(root);
      });
    });
  }

  // ---------------------------------------------------------------
  // Lightbox — tap a product card to see it larger, still rotatable
  // ---------------------------------------------------------------
  function openLightbox(sourceRoot) {
    var box = $("[data-lightbox]");
    if (!box) return;
    var srcFront = sourceRoot.querySelector(".flip3d-front");
    var srcBack = sourceRoot.querySelector(".flip3d-back");
    var dstFront = box.querySelector("[data-lightbox-front]");
    var dstBack = box.querySelector("[data-lightbox-back]");
    if (!srcFront || !srcBack || !dstFront || !dstBack) return;

    dstFront.src = srcFront.src;
    dstFront.alt = srcFront.alt;
    dstBack.src = srcBack.src;
    dstBack.alt = srcBack.alt;

    var lightboxRoot = box.querySelector("[data-flip3d]");
    if (lightboxRoot && lightboxRoot.__flip3dSetAngle) {
      lightboxRoot.__flip3dSetAngle(sourceRoot.__flip3dIsBack && sourceRoot.__flip3dIsBack() ? 180 : 0, false);
    }

    box.setAttribute("aria-hidden", "false");
    box.classList.add("is-open");
    document.documentElement.classList.add("has-lightbox");
  }

  function closeLightbox() {
    var box = $("[data-lightbox]");
    if (!box) return;
    box.setAttribute("aria-hidden", "true");
    box.classList.remove("is-open");
    document.documentElement.classList.remove("has-lightbox");
  }

  // ---------------------------------------------------------------
  // Size guide modal
  // ---------------------------------------------------------------
  function openSizeGuide() {
    var box = $("[data-sizeguide-modal]");
    if (!box) return;
    box.setAttribute("aria-hidden", "false");
    box.classList.add("is-open");
    document.documentElement.classList.add("has-modal");
  }
  function closeSizeGuide() {
    var box = $("[data-sizeguide-modal]");
    if (!box) return;
    box.setAttribute("aria-hidden", "true");
    box.classList.remove("is-open");
    document.documentElement.classList.remove("has-modal");
  }
  function initSizeGuide() {
    var box = $("[data-sizeguide-modal]");
    if (!box) return;
    $$("[data-sizeguide-open]").forEach(function (btn) {
      btn.addEventListener("click", openSizeGuide);
    });
    var closeBtn = box.querySelector("[data-sizeguide-close]");
    if (closeBtn) closeBtn.addEventListener("click", closeSizeGuide);
    box.addEventListener("click", function (e) {
      if (e.target === box) closeSizeGuide();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && box.classList.contains("is-open")) closeSizeGuide();
    });
  }

  // ---------------------------------------------------------------
  // Size calculator — recommends a size from the size-guide tables
  // ---------------------------------------------------------------
  function parseSizeTable(box, type, keyA, keyB) {
    var rows = box.querySelectorAll('.sizeguide-table[data-sizeguide-table="' + type + '"] tbody tr');
    var table = [];
    rows.forEach(function (tr) {
      var cells = tr.querySelectorAll("td");
      if (cells.length < 3) return;
      var row = { label: cells[0].textContent.trim() };
      row[keyA] = parseFloat(cells[1].textContent);
      row[keyB] = parseFloat(cells[2].textContent);
      table.push(row);
    });
    return table;
  }

  function nearestIndex(table, keyA, keyB, valA, valB) {
    var bestIdx = 0;
    var bestDist = Infinity;
    table.forEach(function (row, i) {
      // keyA is the primary measurement for this garment (chest for jerseys,
      // waist for bibs), so it's weighted more than the secondary one.
      var d = Math.abs(row[keyA] - valA) * 1.5 + Math.abs(row[keyB] - valB);
      // On a tie, round up to the larger size (table rows run smallest to
      // largest), matching common brand guidance for in-between measurements.
      if (d <= bestDist) {
        bestDist = d;
        bestIdx = i;
      }
    });
    return bestIdx;
  }

  function initSizeCalculator() {
    var box = $("[data-sizeguide-modal]");
    if (!box) return;

    var tabBtns = $$("[data-sizeguide-tab]", box);
    var panels = $$("[data-sizeguide-panel]", box);
    tabBtns.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var target = btn.getAttribute("data-sizeguide-tab");
        tabBtns.forEach(function (b) {
          b.classList.toggle("is-active", b === btn);
        });
        panels.forEach(function (p) {
          p.hidden = p.getAttribute("data-sizeguide-panel") !== target;
        });
      });
    });

    var form = box.querySelector("[data-sizeguide-calc-form]");
    if (!form) return;
    var result = box.querySelector("[data-sizeguide-calc-result]");
    var jerseyOut = box.querySelector("[data-sizeguide-result-jersey]");
    var bibOut = box.querySelector("[data-sizeguide-result-bib]");

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var chest = parseFloat(form.chest.value);
      var waist = parseFloat(form.waist.value);
      var hip = parseFloat(form.hip.value);
      if (!chest || !waist || !hip) return;

      var fit = (form.querySelector('input[name="fit"]:checked') || {}).value || "normal";
      var offset = fit === "tight" ? -1 : fit === "loose" ? 1 : 0;

      // Jersey: matched on chest + waist (own table, own size run).
      var jerseyTable = parseSizeTable(box, "jersey", "chest", "waist");
      // Bib shorts: matched on hip + waist (own table — currently Gobik's public
      // chart as reference until Velodynn has its own bib measurements).
      var bibTable = parseSizeTable(box, "bib", "waist", "hip");
      if (!jerseyTable.length || !bibTable.length) return;

      var jerseyMaxIdx = jerseyTable.length - 1;
      var jerseyBaseIdx = nearestIndex(jerseyTable, "chest", "waist", chest, waist);
      var jerseyIdx = Math.min(jerseyMaxIdx, Math.max(0, jerseyBaseIdx + offset));

      var bibMaxIdx = bibTable.length - 1;
      // Waist is weighted as the primary measurement (matches how tightly bib
      // shorts are known to fit in practice); hip is the secondary tie-breaker.
      var bibBaseIdx = nearestIndex(bibTable, "waist", "hip", waist, hip);
      var bibIdx = Math.min(bibMaxIdx, Math.max(0, bibBaseIdx + offset));

      if (jerseyOut) jerseyOut.textContent = jerseyTable[jerseyIdx].label;
      if (bibOut) bibOut.textContent = bibTable[bibIdx].label;
      if (result) result.hidden = false;
    });
  }

  // ---------------------------------------------------------------
  // Cart drawer — live AJAX cart, shared by size picker & nav trigger
  // ---------------------------------------------------------------
  function formatMoney(cents) {
    return (Math.round(cents) / 100).toFixed(2).replace(".", ",") + " €";
  }

  function cartItemHTML(item) {
    var variantLine = "";
    if (item.variant_title && item.variant_title !== "Default Title") {
      variantLine = '<p class="cart-drawer-item-variant">' + escHTML(item.variant_title) + "</p>";
    }
    var img = item.image ? '<img src="' + item.image + '" alt="' + escHTML(item.product_title) + '" loading="lazy" />' : "";
    return (
      '<li class="cart-drawer-item" data-variant-id="' + item.variant_id + '">' +
        '<div class="cart-drawer-item-img">' + img + "</div>" +
        '<div class="cart-drawer-item-info">' +
          '<p class="cart-drawer-item-title">' + escHTML(item.product_title) + "</p>" +
          variantLine +
          '<div class="cart-drawer-item-qty">' +
            '<button type="button" class="qty-btn" data-cart-qty-minus aria-label="Menos">−</button>' +
            "<span>" + item.quantity + "</span>" +
            '<button type="button" class="qty-btn" data-cart-qty-plus aria-label="Más">+</button>' +
          "</div>" +
        "</div>" +
        '<div class="cart-drawer-item-side">' +
          '<span class="cart-drawer-item-price">' + formatMoney(item.final_line_price) + "</span>" +
          '<button type="button" class="cart-drawer-item-remove" data-cart-remove aria-label="Eliminar">×</button>' +
        "</div>" +
      "</li>"
    );
  }

  function renderCartDrawer(cart) {
    var itemsList = $("[data-cart-items]");
    var emptyBox = $("[data-cart-empty]");
    var foot = $("[data-cart-foot]");
    if (!itemsList || !cart) return;
    itemsList.innerHTML = cart.items.map(cartItemHTML).join("");
    var hasItems = cart.item_count > 0;
    if (emptyBox) emptyBox.hidden = hasItems;
    if (foot) foot.hidden = !hasItems;
    var subtotalEl = $("[data-cart-subtotal]");
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    $$("[data-cart-count]").forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    applyLang(currentLang);
  }

  function fetchCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
  }

  function openCartDrawer() {
    var drawer = $("[data-cart-drawer]");
    if (!drawer) return;
    drawer.setAttribute("aria-hidden", "false");
    drawer.classList.add("is-open");
    document.documentElement.classList.add("has-modal");
  }
  function closeCartDrawer() {
    var drawer = $("[data-cart-drawer]");
    if (!drawer) return;
    drawer.setAttribute("aria-hidden", "true");
    drawer.classList.remove("is-open");
    document.documentElement.classList.remove("has-modal");
  }

  function changeCartLine(variantId, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function initCartDrawer() {
    var drawer = $("[data-cart-drawer]");
    if (!drawer) return;

    $$("[data-cart-trigger]").forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        e.preventDefault();
        fetchCart().then(renderCartDrawer);
        openCartDrawer();
      });
    });
    $$("[data-cart-drawer-close]", drawer).forEach(function (el) {
      el.addEventListener("click", closeCartDrawer);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && drawer.classList.contains("is-open")) closeCartDrawer();
    });

    var itemsList = $("[data-cart-items]", drawer);
    if (itemsList) {
      itemsList.addEventListener("click", function (e) {
        var li = e.target.closest("[data-variant-id]");
        if (!li) return;
        var variantId = li.getAttribute("data-variant-id");
        var qtySpan = li.querySelector(".cart-drawer-item-qty span");
        var currentQty = parseInt(qtySpan.textContent, 10) || 0;

        if (e.target.closest("[data-cart-qty-plus]")) {
          changeCartLine(variantId, currentQty + 1).then(renderCartDrawer);
        } else if (e.target.closest("[data-cart-qty-minus]")) {
          changeCartLine(variantId, Math.max(0, currentQty - 1)).then(renderCartDrawer);
        } else if (e.target.closest("[data-cart-remove]")) {
          changeCartLine(variantId, 0).then(renderCartDrawer);
        }
      });
    }
  }

  // ---------------------------------------------------------------
  // Account menu — dropdown for logged-in customers
  // ---------------------------------------------------------------
  function initAccountMenu() {
    var menu = $("[data-account-menu]");
    if (!menu) return;
    var dropdown = $("[data-account-dropdown]", menu);
    if (!dropdown) return;
    var trigger = $("[data-account-trigger]", menu);

    trigger.addEventListener("click", function (e) {
      e.preventDefault();
      var isOpen = dropdown.classList.contains("is-open");
      dropdown.classList.toggle("is-open", !isOpen);
      trigger.setAttribute("aria-expanded", String(!isOpen));
    });
    document.addEventListener("click", function (e) {
      if (!menu.contains(e.target)) dropdown.classList.remove("is-open");
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") dropdown.classList.remove("is-open");
    });
  }

  // ---------------------------------------------------------------
  // Size picker — real Shopify variants. Pick a size, add to cart,
  // then open the cart drawer so the shopper can review or continue.
  // ---------------------------------------------------------------
  function initSizePicker() {
    $$("[data-size-picker]").forEach(function (picker) {
      var form = picker.nextElementSibling;
      if (!form || !form.matches("[data-product-form]")) return;
      var input = form.querySelector("[data-selected-variant]");
      var button = form.querySelector("[data-add-to-cart]");
      var label = button.querySelector("[data-add-to-cart-label]");
      var selectLabel = label.textContent;

      $$("[data-size-pill]", picker).forEach(function (pill) {
        pill.addEventListener("click", function () {
          $$("[data-size-pill]", picker).forEach(function (p) { p.classList.remove("is-selected"); });
          pill.classList.add("is-selected");
          input.value = pill.getAttribute("data-variant-id");
          button.disabled = false;
          var dict = I18N[currentLang] || I18N.es || {};
          var buyLabel = dict["collection.buy"] || "Comprar";
          label.textContent = pill.querySelector(".size-pill-label").textContent + " — " + buyLabel;
        });
      });

      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (!input.value) return;
        button.disabled = true;
        var prevLabel = label.textContent;
        label.textContent = "…";
        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: input.value, quantity: 1 })
        })
          .then(function (r) { if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || "error"); }); return r.json(); })
          .then(function () {
            button.disabled = false;
            return fetchCart();
          })
          .then(function (cart) {
            if (cart) {
              renderCartDrawer(cart);
              openCartDrawer();
            }
          })
          .catch(function () {
            label.textContent = selectLabel;
            button.disabled = false;
            alert("Esa talla ya no está disponible. Prueba con otra.");
          });
      });
    });
  }

  // ---------------------------------------------------------------
  // Product page gallery — thumbnails, prev/next, swipe
  // ---------------------------------------------------------------
  function initProductGallery() {
    $$("[data-gallery]").forEach(function (gallery) {
      var mainImg = gallery.querySelector("[data-gallery-img]");
      var thumbs = $$("[data-gallery-thumb]", gallery);
      if (!mainImg || !thumbs.length) return;
      var index = 0;

      function show(i) {
        index = (i + thumbs.length) % thumbs.length;
        var thumb = thumbs[index];
        mainImg.src = thumb.getAttribute("data-src");
        thumbs.forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener("click", function () { show(i); });
      });

      var prevBtn = gallery.querySelector("[data-gallery-prev]");
      var nextBtn = gallery.querySelector("[data-gallery-next]");
      if (prevBtn) prevBtn.addEventListener("click", function () { show(index - 1); });
      if (nextBtn) nextBtn.addEventListener("click", function () { show(index + 1); });

      var mainWrap = gallery.querySelector(".product-gallery-main");
      var startX = null;
      if (mainWrap) {
        mainWrap.addEventListener("touchstart", function (e) { startX = e.touches[0].clientX; }, { passive: true });
        mainWrap.addEventListener("touchend", function (e) {
          if (startX === null) return;
          var dx = e.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 40) show(index + (dx < 0 ? 1 : -1));
          startX = null;
        }, { passive: true });
      }
    });
  }

  // ---------------------------------------------------------------
  // Accordion — product page info sections
  // ---------------------------------------------------------------
  function initAccordion() {
    $$("[data-accordion]").forEach(function (accordion) {
      $$("[data-accordion-trigger]", accordion).forEach(function (trigger) {
        trigger.addEventListener("click", function () {
          var item = trigger.closest(".accordion-item");
          var isOpen = item.classList.contains("is-open");
          item.classList.toggle("is-open", !isOpen);
          trigger.setAttribute("aria-expanded", String(!isOpen));
        });
      });
    });
  }

  function initLightbox() {
    var box = $("[data-lightbox]");
    if (!box) return;
    var closeBtn = box.querySelector("[data-lightbox-close]");
    if (closeBtn) closeBtn.addEventListener("click", closeLightbox);
    box.addEventListener("click", function (e) {
      if (e.target === box) closeLightbox();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && box.classList.contains("is-open")) closeLightbox();
    });
  }

  // ---------------------------------------------------------------
  // Collection cards — "Reservar" pre-fills the product field
  // ---------------------------------------------------------------
  function initSelectProduct() {
    var field = $("#c-product");
    if (!field) return;
    $$("[data-select-product]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        field.value = btn.getAttribute("data-select-product");
        field.dispatchEvent(new Event("input"));
        var target = $("#reserva-colecciones");
        if (target) {
          window.scrollTo({
            top: target.getBoundingClientRect().top + scrollY - 112,
            behavior: reduced ? "auto" : "smooth"
          });
        }
        setTimeout(function () { $("#c-name") && $("#c-name").focus(); }, reduced ? 0 : 500);
      });
    });
  }

  // ---------------------------------------------------------------
  // Count-up (year founded / km tested, etc.)
  // ---------------------------------------------------------------
  function initCountUp() {
    $$("[data-count-to]").forEach(function (el) {
      var target = parseFloat(el.dataset.countTo);
      var decimals = (el.dataset.countTo.split(".")[1] || "").length;
      var obj = { v: 0 };
      var fired = false;
      var trigger = function () {
        if (fired) return;
        fired = true;
        if (window.gsap) {
          gsap.to(obj, {
            v: target, duration: 1.3, ease: "power2.out",
            onUpdate: function () { el.textContent = obj.v.toFixed(decimals); }
          });
        } else {
          el.textContent = target.toFixed(decimals);
        }
      };
      if (typeof IntersectionObserver === "undefined") { trigger(); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { trigger(); io.unobserve(e.target); } });
      }, { threshold: 0.05 });
      io.observe(el);
      setTimeout(function () {
        if (el.getBoundingClientRect().top < window.innerHeight) trigger();
      }, 6000);
    });
  }

  // ---------------------------------------------------------------
  // Contact / reserve form — submits to Shopify's native contact form
  // handler (AJAX), which emails the store's notification inbox directly.
  // No mailto fallback: delivery no longer depends on the visitor's own
  // email client actually being set up and them hitting "send" themselves.
  // ---------------------------------------------------------------
  function setupContactForm() {
    $$("form.cta-form").forEach(function (form) {
      var wrap = form.parentElement;
      var success = wrap.querySelector("[data-contact-success]");
      if (!success) return;
      var submitBtn = form.querySelector("[type=submit]");
      var msg = wrap.querySelector("[data-contact-success-msg]");

      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (form.classList.contains("is-sending")) return;
        if (!form.reportValidity()) return;

        form.classList.add("is-sending");
        if (submitBtn) submitBtn.disabled = true;

        var nameField = form.querySelector('input[name="contact[name]"]');
        var firstName = nameField ? (nameField.value.trim().split(/\s+/)[0] || "") : "";
        var brandEmail = data.email || "info@velodynn.com";

        // Shopify's /contact handler replies with a redirect, which this
        // fetch can't always read back (cross-origin during theme preview,
        // opaque in no-cors) even though the message goes through fine.
        // So: mode "no-cors" always resolves once the request lands — we
        // treat that resolution as success. Only a real network failure
        // (offline, DNS, etc.) rejects and shows the error state.
        fetch(form.action, {
          method: "POST",
          mode: "no-cors",
          body: new FormData(form)
        })
          .then(function () {
            form.classList.remove("is-sending");
            form.classList.add("is-sent");
            success.setAttribute("aria-hidden", "false");
            success.classList.add("is-visible");
            if (msg) {
              var dict = I18N[currentLang] || I18N.es || {};
              msg.textContent = firstName
                ? (dict["form.success.named"] || "{name}, {email}").replace("{name}", firstName).replace("{email}", brandEmail)
                : (dict["form.success.generic"] || "");
            }
            form.reset();
          })
          .catch(function () {
            form.classList.remove("is-sending");
            if (submitBtn) submitBtn.disabled = false;
            alert("No se ha podido enviar. Prueba de nuevo o escríbenos directamente a " + brandEmail + ".");
          });
      });
    });
  }

  // ---------------------------------------------------------------
  // Newsletter — subscribes via Shopify's native customer form
  // (contact[tags]=newsletter), so signups land as real customers.
  // ---------------------------------------------------------------
  function setupNewsletterForm() {
    var form = $("#newsletter-form");
    if (!form) return;
    var success = form.querySelector("[data-newsletter-success]");
    var submitBtn = form.querySelector("[type=submit]");
    var emailInput = form.querySelector("#newsletter-email");

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      if (form.classList.contains("is-sending")) return;
      if (!form.reportValidity()) return;

      form.classList.add("is-sending");
      if (submitBtn) submitBtn.disabled = true;

      fetch(form.action, {
        method: "POST",
        mode: "no-cors",
        body: new FormData(form)
      })
        .then(function () {
          form.classList.remove("is-sending");
          if (success) {
            success.setAttribute("aria-hidden", "false");
            success.classList.add("is-visible");
          }
          if (emailInput) emailInput.value = "";
        })
        .catch(function () {
          form.classList.remove("is-sending");
          if (submitBtn) submitBtn.disabled = false;
          alert("No se ha podido completar la suscripción. Prueba de nuevo.");
        });
    });
  }

  // ---------------------------------------------------------------
  // i18n — language switch (es / ca / en / fr)
  // ---------------------------------------------------------------
  function getStoredLang() {
    var saved = null;
    try { saved = localStorage.getItem(LANG_KEY); } catch (_e) {}
    return SUPPORTED_LANGS.indexOf(saved) > -1 ? saved : "es";
  }

  function applyLang(lang) {
    if (SUPPORTED_LANGS.indexOf(lang) === -1) lang = "es";
    var dict = I18N[lang] || I18N.es;
    if (!dict) return;
    currentLang = lang;

    $$("[data-i18n]").forEach(function (el) {
      var key = el.getAttribute("data-i18n");
      if (dict[key] != null) el.textContent = dict[key];
    });
    $$("[data-i18n-aria]").forEach(function (el) {
      var key = el.getAttribute("data-i18n-aria");
      if (dict[key] != null) el.setAttribute("aria-label", dict[key]);
    });
    $$("[data-i18n-placeholder]").forEach(function (el) {
      var key = el.getAttribute("data-i18n-placeholder");
      if (dict[key] != null) el.setAttribute("placeholder", dict[key]);
    });
    $$("[data-i18n-html]").forEach(function (el) {
      var key = el.getAttribute("data-i18n-html");
      if (dict[key] != null) el.innerHTML = dict[key];
    });

    var metaPrefix = document.body.getAttribute("data-meta-prefix");
    var titleKey = metaPrefix ? metaPrefix + ".meta.title" : "meta.title";
    var descKey = metaPrefix ? metaPrefix + ".meta.description" : "meta.description";
    if (dict[titleKey]) document.title = dict[titleKey];
    var metaDesc = $('meta[name="description"]');
    if (metaDesc && dict[descKey]) metaDesc.setAttribute("content", dict[descKey]);

    document.documentElement.setAttribute("lang", lang);

    $$("[data-lang]").forEach(function (btn) {
      var isActive = btn.getAttribute("data-lang") === lang;
      btn.classList.toggle("is-active", isActive);
      btn.setAttribute("aria-pressed", isActive ? "true" : "false");
    });

    try { localStorage.setItem(LANG_KEY, lang); } catch (_e) {}
  }

  function initI18n() {
    $$("[data-lang]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        applyLang(btn.getAttribute("data-lang"));
      });
    });
    applyLang(getStoredLang());
  }

  // ---------------------------------------------------------------
  // Boot
  // ---------------------------------------------------------------
  function boot() {
    safe(mountNav, "mountNav");
    safe(mountPillars, "mountPillars");
    safe(mountDetails, "mountDetails");
    safe(mountFooterMeta, "mountFooterMeta");

    safe(initSplash, "initSplash");
    safe(initNav, "initNav");
    safe(initSmoothAnchors, "initSmoothAnchors");
    safe(initReveals, "initReveals");
    safe(initMaskReveals, "initMaskReveals");
    safe(initTilt, "initTilt");
    safe(initMagnetic, "initMagnetic");
    safe(initSignature, "initSignature");
    safe(initSelectProduct, "initSelectProduct");
    safe(initFlip3D, "initFlip3D");
    safe(initLightbox, "initLightbox");
    safe(initSizeGuide, "initSizeGuide");
    safe(initSizeCalculator, "initSizeCalculator");
    safe(initSizePicker, "initSizePicker");
    safe(initCartDrawer, "initCartDrawer");
    safe(initAccountMenu, "initAccountMenu");
    safe(initProductGallery, "initProductGallery");
    safe(initAccordion, "initAccordion");
    safe(initCountUp, "initCountUp");
    safe(setupContactForm, "setupContactForm");
    safe(setupNewsletterForm, "setupNewsletterForm");
    safe(initI18n, "initI18n");

    if (window.gsap && window.ScrollTrigger) {
      try { gsap.registerPlugin(ScrollTrigger); } catch (_e) {}
      safe(initHeroParallax, "initHeroParallax");
      safe(initPhotoParallax, "initPhotoParallax");
    }

    document.documentElement.classList.add("is-ready");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
